export function parseCookie(cookieString: string) {
  return cookieString.split(";").reduce((acc, cookieEntry) => {
    const splitValues = cookieEntry.split("=");
    if (splitValues.length > 2) {
      const keyToUse = splitValues[0].trim();
      splitValues.splice(0, 1);
      acc[keyToUse] = splitValues
        .join("=")
        .split("&")
        .reduce((valueObject, valueEntry) => {
          const [key, value] = valueEntry.split("=");
          valueObject[key.trim()] = decodeURIComponent(value);
          return valueObject;
        }, {});
    } else {
      acc[splitValues[0].trim()] = splitValues[1];
    }
    return acc;
  }, {});
}

export function getCookie(name: string): string | undefined {
  if (typeof document === "undefined") {
    return undefined;
  }
  const cookieString = document.cookie;
  const index = cookieString.indexOf(`${name}=`);
  if (index === -1) {
    return undefined;
  }
  const end = cookieString.indexOf(";", index);
  if (end === -1) {
    return decodeURIComponent(cookieString.substring(index + name.length + 1));
  }
  return decodeURIComponent(
    cookieString.substring(
      // start, end
      index + name.length + 1,
      end
    )
  );
}

export function parseCookies() {
  return parseCookie(document.cookie);
}
